// Shared mapping between the backend's English chat-tool identifiers and the
// Hebrew labels that should appear in the UI (chat transparency badges, etc.).
// Anything not mapped falls back to a generic "מקור AI" label so we never leak
// raw English function names like "getTopGrowers" to the end user.

export const TOOL_LABELS = {
  getTopGrowers: "פריטים בצמיחה",
  compareBranches: "השוואת סניפים",
  getRevenueTrend: "מגמת מחזור",
  getTopProducts: "מובילי מכירות",
  getPriceVariance: "פערי מחירים",
  getCatalogConcentration: "ריכוז קטלוג",
  getExecutiveSummary: "סיכום ניהולי",
  getMonthlyRevenue: "מחזור חודשי",
  getDayOfWeekPattern: "ימי שבוע",
  getDatasetInfo: "מידע על הדאטה",
  getPurchaseRecommendations: "המלצות רכש",
  searchProducts: "חיפוש פריט",
  getProductDetail: "פרטי פריט",
  getDataQualitySignals: "איכות נתונים",
  getLoyalInvoices: "חשבוניות מרוכזות",
  getInventoryKpis: "סטטוס מלאי",
  getStockouts: "חסרים במלאי",
  getCriticalRestock: "מלאי דחוף",
  getDeadStock: "הון ללא תנועה",
  getSkuInventory: "מלאי פריט",
};

export function toolLabel(name) {
  if (!name) return "מקור AI";
  const key = typeof name === "string" ? name : name?.name;
  return TOOL_LABELS[key] || "מקור AI";
}
